import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'

//@ts-ignore
import LKButton from 'shared/LKButton'
import { ClientEditButtonProps } from './ClientAccountChoosePanel.types'

const ClientEditButton: FC<ClientEditButtonProps> = ({
  form,
  disabled,
  client,
  searchAndChooseClient,
  openClientEdit,
}) => {
  const selectFormValue = formValueSelector(form)

  const clientIsChosen: boolean = useSelector((state) => selectFormValue(state, 'clientIsChosen'))
  const clientID: number = useSelector((state) => selectFormValue(state, 'clientID'))
  const clientHash: string = useSelector((state) => selectFormValue(state, 'clientHash'))
  const clientType: string = useSelector((state) => selectFormValue(state, 'ClientType'))
  const currentCardNumber: string = useSelector((state) => selectFormValue(state, 'CardNumberSearch'))

  const [fetching, setFetching] = React.useState(false)

  return (
    <LKButton
      disabled={!clientID && !client && (fetching || disabled || !clientIsChosen)}
      loading={fetching}
      onClick={() => {
        if (!clientIsChosen && !clientID) {
          setFetching(true)
          searchAndChooseClient(currentCardNumber)
            .then((data) => {
              openClientEdit({
                name: 'ClientEditInOrderAdd',
                ID: data.ID,
                hash: data.HashSum_ClientID_,
                ClientType: data.ClientTypeID,
                clientReqFieldGroupID: 9,
              })
            })
            .catch((error) => console.error(error))
            .finally(() => setFetching(false))
        } else if (clientID) {
          openClientEdit({
            name: 'ClientEditInOrderAdd',
            ID: clientID,
            hash: clientHash,
            ClientType: Number(clientType),
            clientReqFieldGroupID: 9,
          })
        }
      }}
      alias="edit"
    />
  )
}

export default ClientEditButton
